import React from 'react'
import { Nav, Navbar, Container, NavItem, NavDropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Home from '../home';
import Services from '../services';
import Initiatives from '../initiatives';
import VisionAndMessage from '../visionAndMessage';
import TwentyThirtyVision from '../twentyThirtyVision';
import CeoWord from '../ceoWord';
import FAQ from '../faq';
export default class navbar extends React.Component {
    constructor(props) {
        super(props);
        this.closeNavbar = this.closeNavbar.bind(this);
        this.state = {
            collapsed: true,
            bg: "transparent"
        };
    }
    closeNavbar() {
        if (this.state.collapsed !== true) {
            this.toggleNavbar();
        }
    }
    /*     listenScrollEvent = e => {
            if (window.scrollY > 50) {
              this.setState({ bg: "alt" });
            } else {
              this.setState({ bg: "transparent" });
            }
          };
        
          componentDidMount() {
            window.addEventListener("scroll", this.listenScrollEvent);
          } */
    render() {
        return (
            <>
                <BrowserRouter>
                    <Navbar bg='alt' expand="lg" fixed="top">
                        <Container className="navbar-container ">
                            <Navbar.Brand className=" " href="/">
                                <img src='https://i.ibb.co/2hqdPXn/LOGO-1-copy.png' className="d-inline-block align-top" height="60" alt="logo" />
                            </Navbar.Brand>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav">
                                <Nav className="navbar-ul mr-auto rtl">
                                    <NavLink to="/" className="nav-link" activeClassName="nav-link--active" >الرئيسية
                            </NavLink>
                                    <NavDropdown title="عن هاد" id="collasible-nav-dropdown" >
                                        <NavDropdown.Item  >
                                            <NavLink to="/ceoWord" className="nav-link"  > كلمة المدير التنفيذي
                                     </NavLink>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item>
                                            <NavLink to="/VisionAndMessage" className="nav-link" activeClassName="nav-link--active" >الرؤية والرسالة
                                     </NavLink>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item >
                                            <NavLink to="/twentyThirtyVision" className="nav-link" activeClassName="nav-link--active" >
                                                دور هاد في رؤية 2030
                                     </NavLink>
                                        </NavDropdown.Item>
                                    </NavDropdown>

                                    {/*  <NavDropdown title="الخدمات" id="collasible-nav-dropdown">
                                    <NavDropdown.Item>
                                        <NavLink to="/services" className="nav-link" activeClassName="nav-link--active" > انهاء إجراءات تأسيس المنشأة
                                     </NavLink>
                                        </NavDropdown.Item>
                                    <NavDropdown.Item>
                                    <NavLink to="/TheLaboratory" className="nav-link" activeClassName="nav-link--active" >إدارة حسابات المنشأة في المواقع الحكومية
                                     </NavLink>
                                    </NavDropdown.Item>
                                </NavDropdown> */}
                                    <NavLink to="/services" className="nav-link" activeClassName="nav-link--active" >الخدمات
                            </NavLink>
                                    <NavLink to="/initiatives" className="nav-link" activeClassName="nav-link--active" >المبادرات
                            </NavLink>
                                    <NavLink to="/FAQ" className="nav-link" activeClassName="nav-link--active" >الاسئلة الشائعة
                            </NavLink>
                                </Nav>

                            </Navbar.Collapse>
                        </Container>
                    </Navbar>

                    <Switch>
                        <Route path="/" component={Home} exact />
                        <Route path="/services" component={Services} />
                        <Route path="/initiatives" component={Initiatives} />
                        <Route path="/VisionAndMessage" component={VisionAndMessage} />
                        <Route path="/twentyThirtyVision" component={TwentyThirtyVision} />
                        <Route path="/ceoWord" component={CeoWord} />
                        <Route path="/FAQ" component={FAQ} />
                    </Switch>

                </BrowserRouter>


            </>
        )
    }
}
